import React, {useState} from 'react';
import axios from 'axios';
import {FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import {EmailField} from '../utils/validation/auth/AuthValidators';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/login/LoginForm.module.css';
import ErrorMessage from '../elements/ErrorMessage';


const RequestTokenForm = (props) => {
    const {email, setEmail, changeStep} = props;
    const [isLoading, editIsLoading] = useState(false);
    const [hasError, editHasError] = useState(false);

    //load validation rules for fields
    const ValidationRules = {
        email: EmailField
    };

    //blur validation
    function validateFieldOnBlur(e){
        const value = e.target.value;
        const id= e.target.id;
        const res = ValidationRules[id](value);
        ShowValidation(id, res);
    }

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        let validForm = FormValidator('forgotPasswordForm', ValidationRules); 
        if (validForm) {
            editIsLoading(true);
            try{
                editHasError(false);
                const response = await axios({
                    method: "post",
                    url: process.env.NEXT_PUBLIC_API + "/api/forgot-password",
                    data: {email: email},
                    headers: {'Content-Type': 'application/json'}
                });
                editIsLoading(false);
               
                if (response.data.status==true) {
                    changeStep('token');
                } else {
                   editHasError(response.data.error);
                }
                
            } catch(err) {
                editIsLoading(false);
                editHasError("Ups, avem o problemă. Te rugăm să încerci mai târziu.");
            }
        }

    }

    const spinner = isLoading &&  <><Spinner as="span" animation="grow" size="sm" role="status"
                                    aria-hidden="true" />
                                    Te rugăm să aștepți...
                                    </>;
    const btnDisabled = isLoading && 'disabled';
    const resetPasswordBtn =  <Button variant="secondary" type="submit" className="col-12" disabled={btnDisabled}  >
    {spinner}
    {!isLoading && 'Continuă'}
    </Button>;

    const errorMessage = hasError && <div className="mb-3">
                        <ErrorMessage title="Eroare" message={hasError} />
                        </div>; 



    return(
        <>
            {hasError ? errorMessage :
                <p className={styles.wizzardTitle}>
                    Completeaza adresa de email cu care te-ai înregistrat pe Conso.
                </p>
            }
            <Form id="forgotPasswordForm" onSubmit={handlePasswordReset}>
                <Form.Group controlId="email">
                    <Form.Label className={styles.login}>Email</Form.Label>
                    <Form.Control type="text" name="email" placeholder="Adresa de email" 
                        onChange={setEmail} 
                        onBlur={validateFieldOnBlur}
                        value={email}         
                    />
                    <Form.Text className="helper" as="div">    
                    </Form.Text>
                </Form.Group>  
                {resetPasswordBtn}
            </Form>     
        </>
    );
}

export default RequestTokenForm;